import React from "react";

import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Beautyfloatingbutton from "../../components/beautyfloatingbutton";

import underarmwax1 from "../images/services/waxing/underarmwax1.webp";
import underarmwax2 from "../images/services/waxing/underarmwax2.webp";
import underarmwax3 from "../images/services/waxing/underarmwax3.webp";
import underarmwax4 from "../images/services/waxing/underarmwax4.webp";





import "./underarmwax.css";

// dummy image (replace later)


const CleanupServices = () => {
    const services = [
        {
            title: "Sara Fruit Cleanup",
            price: 699,
            img: underarmwax1,
            bookingLink: "https://wa.me/919836904698?text=I want Sara Fruit Cleanup",
            time: "45 mins",
            tag: "Bestseller",
            points: [
                "Provides antioxidant protection",
                "Removes dirt & pollution",
                "Suitable for all skin types",
            ],
        },
        {
            title: "Detan Cleanup",
            price: 599,
            img: underarmwax2,
            bookingLink: "https://wa.me/919836904698?text=I want Sara Fruit Cleanup",
            time: "40 mins",
            tag: "Popular",
            points: [
                "Removes tanning instantly",
                "Brightens dull skin",
                "Even skin tone",
            ],
        },
        {
            title: "Gold Cleanup",
            price: 799,
            img: underarmwax3,
            bookingLink: "https://wa.me/919836904698?text=I want Sara Fruit Cleanup",
            time: "50 mins",
            tag: "Premium",
            points: [
                "Adds instant glow",
                "Deep skin nourishment",
                "Improves texture",
            ],
        },
        {
            title: "Diamond Cleanup",
            price: 899,
            img: underarmwax4,
            bookingLink: "https://wa.me/919836904698?text=I want Sara Fruit Cleanup",
            time: "55 mins",
            tag: "Luxury",
            points: [
                "High-end facial glow",
                "Skin rejuvenation",
                "Long-lasting shine",
            ],
        },
        {
            title: "Aloe Vera Cleanup",
            price: 499,
            img: underarmwax1,
            bookingLink: "https://wa.me/919836904698?text=I want Sara Fruit Cleanup",
            time: "35 mins",
            tag: "New",
            points: [
                "Soothes sensitive skin",
                "Hydrates deeply",
                "Reduces irritation",
            ],
        },
        {
            title: "Charcoal Cleanup",
            price: 649,
            img: underarmwax3,
            bookingLink: "https://wa.me/919836904698?text=I want Sara Fruit Cleanup",
            time: "45 mins",
            tag: "Trending",
            points: [
                "Deep pore cleansing",
                "Removes blackheads",
                "Controls oil",
            ],
        },
        {
            title: "Vitamin C Cleanup",
            price: 749,
            img: underarmwax4,
            bookingLink: "https://wa.me/919836904698?text=I want Sara Fruit Cleanup",
            time: "50 mins",
            tag: "Recommended",
            points: [
                "Boosts skin radiance",
                "Reduces pigmentation",
                "Improves skin tone",
            ],
        },
    ];

    return (
        <>
            <Header />
            <Navbar />

            <div className="container my-4">

                <h4 className="fw-bold mb-4">ComfortBikini Wax Services</h4>

                {services.map((service, idx) => (
                    <div key={idx} className="service-card mb-4">

                        <div className="row align-items-center">

                            {/* LEFT CONTENT */}
                            <div className="col-7">

                                <h5 className="fw-bold mb-1">{service.title}</h5>

                                <div className="mb-2 text-muted small">
                                    ₹{service.price} • {service.time}
                                </div>

                                {/* TAG */}
                                <span className="service-tag">{service.tag}</span>

                                {/* BULLETS */}
                                <ul className="service-points mt-2">
                                    {service.points.map((point, i) => (
                                        <li key={i}>{point}</li>
                                    ))}
                                </ul>

                                {/* BUTTON */}
                                <a
                                    href={service.bookingLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary btn-sm mt-2"
                                >
                                    Book Now
                                </a>

                            </div>

                            {/* RIGHT IMAGE */}
                            <div className="col-5 text-end">
                                <img
                                    src={service.img}
                                    alt={service.title}
                                    className="service-img"
                                />
                            </div>

                        </div>

                    </div>
                ))}

            </div>

            <Footer />
            <Beautyfloatingbutton />
        </>
    );
};

export default CleanupServices;